import { DocumentIcon } from "components/icons/DocumentIcon";
import { LeftBarItem } from "components/Sidebar/LeftBar";
import { DOCUMENTS_CLICKED_FROM_SIDEBAR } from "constants/analyticsEvents";
import { useAnalytics } from "hooks/useAnalytics";
import { parse, stringify } from "qs";
import { useLocation } from "react-router-dom";

export const DocumentsNavItem = () => {
  const { trackEvent } = useAnalytics();
  const location = useLocation();

  const parsedSearch = parse(location.search, { ignoreQueryPrefix: true });

  const search = stringify(
    { entity: parsedSearch.entity, company: parsedSearch.company },
    { skipNulls: true, addQueryPrefix: true }
  );

  const handleClick = () => {
    trackEvent(DOCUMENTS_CLICKED_FROM_SIDEBAR);
  };

  return (
    <button className="all:unset t-w-full" onClick={handleClick}>
      <LeftBarItem to={`/documents/${search}`} icon={DocumentIcon}>
        Documents
      </LeftBarItem>
    </button>
  );
};
